export const FEATURE_FLAG_IDENTITY='identity'
export const FEATURE_FLAG_RESTYLE='restyle'
export const FEATURE_FLAG_VIDEO_LIBRARY_UI_REWORK='videoLibraryUiRework'
export const FEATURE_FLAG_ONE_TO_ONE_PREMIUM='oneToOnePremium'